import type { TraffickingFilters, TraffickingFiltersInput } from '../../../../apis/graphql/types';

export const CustomFilterVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentional const-object + companion union type (enum idiom)
export type CustomFilterVisibility = typeof CustomFilterVisibility[keyof typeof CustomFilterVisibility];

export const CustomFilterType = {
  GLOBAL: 'GLOBAL',
  USER: 'USER',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentional const-object + companion union type (enum idiom)
export type CustomFilterType = typeof CustomFilterType[keyof typeof CustomFilterType];

export type TraffickingCustomFilterSummary = {
  id: string;
  name: string;
  visibility: CustomFilterVisibility;
  createdByMe: boolean;
  type: CustomFilterType;
};

export type TraffickingCustomFilterFull = TraffickingCustomFilterSummary & {
  payload: TraffickingFilters;
};

// Raw backend response shapes (before UI mapping)
type RawTraffickingCustomFilterNode = {
  id: string;
  filterName: string;
  filterType: string;
  visibility: string;
  createdBy: string;
};

type RawTraffickingCustomFilterFull = {
  id: string;
  filterName: string;
  filterType: string;
  visibility: string;
  filterPayload: TraffickingFilters;
  createdBy: string;
};

export type TraffickingCustomFiltersQueryResponse = {
  traffickingCustomFilters: {
    edges: { node: RawTraffickingCustomFilterNode }[];
    total: number;
  };
};

export type TraffickingCustomFiltersQueryVariables = {
  input: {
    pageScope: string;
    searchString?: string | null;
    sort?: string | null;
  };
};

export type TraffickingCustomFilterQueryResponse = {
  traffickingCustomFilter: RawTraffickingCustomFilterFull | null;
};

export type TraffickingCustomFilterQueryVariables = {
  id: string;
};

export type CreateTraffickingCustomFilterMutationResponse = {
  createTraffickingCustomFilter: RawTraffickingCustomFilterFull;
};

export type CreateTraffickingCustomFilterMutationVariables = {
  input: {
    filterName: string;
    pageScope: string;
    visibility?: CustomFilterVisibility;
    filterPayload: CustomFilterPayload;
  };
};

// filterPayload on the backend is a free-form JSONDataType scalar, so displayOrder
// can be stored alongside filter values without any schema change.
export type CustomFilterPayload = TraffickingFiltersInput & { displayOrder?: string[] };

export type UpdateTraffickingCustomFilterInput = {
  filterName?: string;
  visibility?: CustomFilterVisibility;
  filterPayload?: CustomFilterPayload;
};

export type UpdateTraffickingCustomFilterMutationResponse = {
  updateTraffickingCustomFilter: RawTraffickingCustomFilterNode;
};

export type UpdateTraffickingCustomFilterMutationVariables = {
  id: string;
  input: UpdateTraffickingCustomFilterInput;
};

export type DeleteTraffickingCustomFilterMutationResponse = {
  deleteTraffickingCustomFilter: boolean;
};

export type DeleteTraffickingCustomFilterMutationVariables = {
  id: string;
};
